import { useState, useEffect, useMemo } from "react";
import Image from "next/image";
import { toast } from "@/components/common/Toast";
import { emailRegister, resetPassword } from "@/pages/api/auth";
import Cookies from "js-cookie";
import { eventBus, LOGIN_SUCCESS_EVENT } from "@/utils/eventBus";
import { useTranslation } from "next-i18next";
import PasswordInput from "../ui/PasswordInput";
import { Progress } from "react-vant";
import AlreadyHaveAccount from "@/components/login/ui/AlreadyHaveAccount";
import { login } from "@/pages/api/auth";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useElapsedTime } from "@/utils/useElapsedTime";
import { useRouter } from "next/router";
interface SetPasswordFormProps {
  goLogin: () => void;
  onClose: () => void;
  userInputEmail: string;
  verifyCodeType: string;
  handleEmailChange: (email: string) => void;
}
const SetPasswordForm = ({
  goLogin,
  onClose,
  userInputEmail,
  verifyCodeType,
  handleEmailChange,
}: SetPasswordFormProps) => {
  const { t } = useTranslation("");
  const getElapsed = useElapsedTime();
  const pageId =
    verifyCodeType === "0"
      ? "mailsignup_setpassword_web"
      : "maillogin_setpassword_web";
  const router = useRouter();
  const [password, setPassword] = useState("");
  const [rules, setRules] = useState({
    rule1: false,
    rule2: false,
  });
  const [disabled, setDisabled] = useState(true);

  // 预编译正则表达式
  const reg = useMemo(
    () => /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{6,}$/,
    []
  );

  useEffect(() => {
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageView",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
    });
  }, []);
  const handleLeft = () => {
    console.log("handleLeft---set-password-form----");
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageLeave",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
      UM_Key_Duration: getElapsed(),
    });
  };
  useEffect(() => {
    return () => {
      handleLeft();
    };
  }, []);
  // 使用useMemo优化密码校验逻辑
  const passwordRules = useMemo(() => {
    const rules = {
      rule1: false,
      rule2: false,
    };

    if (password.length >= 6 && password.length <= 32) {
      rules.rule1 = true;
    }

    // 包含字母、数字、特殊字符
    if (reg.test(password)) {
      rules.rule2 = true;
    }

    return rules;
  }, [password, reg]);

  // 使用useMemo计算按钮是否禁用
  const isDisabled = useMemo(() => {
    return !(passwordRules.rule1 && passwordRules.rule2);
  }, [passwordRules]);

  // 更新状态
  useEffect(() => {
    setRules(passwordRules);
    setDisabled(isDisabled);
  }, [passwordRules, isDisabled]);

  // 使用防抖处理密码输入
  const handlePasswordChange = (value: string) => {
    setPassword(value);
  };
  const hanldeLogin = (email: string, password: string) => {
    login({
      email,
      password,
    })
      .then((res) => {
        console.log("res-----", res);
        if (res?.data.userInfoBaseResp?.token) {
          toast.success(t("login.suc"));
          console.log(
            "res?.data.userInfoBaseResp?.token",
            res?.data.userInfoBaseResp?.token
          );
          // 设置 cookie，有效期 7 天
          Cookies.set("token", res?.data.userInfoBaseResp?.token, {
            expires: 30,
            path: "/",
            sameSite: "lax",
          });
          Cookies.set("uid", res?.data.userInfoBaseResp?.id, {
            expires: 30,
            path: "/",
            sameSite: "lax",
          });
          // 登录成功
          localStorage.setItem("isLoggedIn", "true");
          // 触发登录成功事件
          eventBus.emit(LOGIN_SUCCESS_EVENT, {
            userId: res?.data.userInfoBaseResp?.id,
            userInfoBaseResp: res?.data.userInfoBaseResp,
          });
          onClose();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  // 注册
  const register = async (password: string) => {
    const res = await emailRegister({
      email: userInputEmail,
      password,
    });
    console.log("register", res);
    if (res?.userInfoBaseResp?.token) {
      toast.success(t("login.suc"));
      // 设置 cookie，有效期 7 天
      Cookies.set("token", res?.userInfoBaseResp.token, {
        expires: 30,
        path: "/",
        sameSite: "lax",
      });
      Cookies.set("uid", res?.id, {
        expires: 30,
        path: "/",
        sameSite: "lax",
      });
      // 登录成功
      localStorage.setItem("isLoggedIn", "true");
      eventBus.emit(LOGIN_SUCCESS_EVENT, {
        userId: res?.userInfoBaseResp?.id,
        userInfoBaseResp: res?.userInfoBaseResp,
      });
      onClose();
    } else {
      toast.error(t("login.toast.registry_failed"));
    }
  };
  // reset密码
  const reset = async (password: string) => {
    const res = (await resetPassword({
      email: userInputEmail,
      password,
    })) as { code: string };
    if (res?.code === "00000") {
      // toast.success(t("login.toast.resetSuc"));
      hanldeLogin(userInputEmail, password);
    } else {
      toast.error(t("login.toast.resetFail"));
    }
  };

  const handleSubmitPassword = async (password: string) => {
    if (isDisabled) {
      return;
    }
    if (verifyCodeType === "0") {
      await register(password);
    } else {
      await reset(password);
    }
  };
  return (
    <div className="flex flex-col w-[calc(100vw-40px)]">
      {verifyCodeType === "1" && (
        <div className="w-full mb-[22px] mt-[16px]">
          <Progress
            style={{ width: "100%", borderRadius: "100px" }}
            strokeWidth={5}
            trackColor={"#eee"}
            percentage="100"
            color="#1677FF"
            showPivot={false}
          ></Progress>
        </div>
      )}
      <PasswordInput
        value={password}
        placeholder={t("login.pswDesc")}
        onChange={handlePasswordChange}
        classNames="bg-[#f2f2f2] mt-[24px]  text-[#333]  rounded-[100px] h-[56px] ps-[20px] pe-[20px] font-[700] text-[16px] font-['Mulish'] "
      ></PasswordInput>
      <div
        className={` flex flex-row justify-start items-center  text-[11px] letter-spacing-[0.3px] font-['Mulish'] font-[400] ${
          rules.rule1 ? "text-[#1EAD5E]" : "text-[#999]"
        } mt-[14px] mb-[11px]`}
      >
        <Image
          src={`${
            rules.rule1
              ? "https://img.buscari.com/img/20250822-184544-pass.png"
              : "https://img.buscari.com/img/20250822-184457-unpass.png"
          }`}
          alt=""
          width={12}
          height={12}
        ></Image>{" "}
        {t("login.passwordLenTip")}
      </div>

      <div
        className={`flex flex-row justify-start items-center  text-[11px] letter-spacing-[0.3px] font-['Mulish'] font-[400] ${
          rules.rule2 ? "text-[#1EAD5E]" : "text-[#999]"
        }`}
      >
        {" "}
        <Image
          src={`${
            rules.rule2
              ? "https://img.buscari.com/img/20250822-184544-pass.png"
              : "https://img.buscari.com/img/20250822-184457-unpass.png"
          }`}
          alt=""
          width={12}
          height={12}
        ></Image>{" "}
        {t("login.passwordRuleTip")}
      </div>
      <div
        onClick={() => {
          handleSubmitPassword(password);
        }}
        className={`${
          disabled ? "bg-[#1673FF] opacity-[0.3]" : "bg-[#1673FF]"
        } rounded-[4px] text-[16px] font-['Mulish'] font-[700] text-[#fff] text-center mt-[116px] h-[48px] flex items-center justify-center`}
      >
        {verifyCodeType === "0"
          ? t("login.registerComplete")
          : t("login.resetPswCompleted")}
      </div>

      {verifyCodeType === "0" ? (
        <AlreadyHaveAccount
          pageId={pageId}
          goLogin={() => {
            handleEmailChange("");
            goLogin();
          }}
          classNames="mt-[11px] mb-[11px]"
        />
      ) : null}
    </div>
  );
};

export default SetPasswordForm;
